import JobsLog from '../../../store/queue/index';

angular
    .module('festzelt-os.queue')
    .factory('JobsLog', [
        '$injector',
        'JobLog',
        ($injector, JobLog) => new JobsLog(JobLog, {
            injector: $injector
        })
    ]);



// WEBPACK FOOTER //
// ./src/app/pages/queue/store/jobs-log.js